<template>
    <div class="calendar-view">
        <header class="dynamic-header btn-toolbar justify-content-between">
            <div class="btn-group">
                <h4>{{ title }}</h4>
            </div>
            <div class="btn-group">
                <button class="btn btn-outline-primary" v-on:click="handlePreviousMonth">
                    <i class="material-icons">arrow_back</i>
                </button>
                <button class="btn btn-outline-primary" v-on:click="handleNextMonth">
                    <i class="material-icons">arrow_forward</i>
                </button>
            </div>
        </header>
        <table class="calendar-grid" ref="calendarGrid">
            <thead>
                <tr>
                    <th>Dom</th>
                    <th>Seg</th>
                    <th>Ter</th>
                    <th>Qua</th>
                    <th>Qui</th>
                    <th>Sex</th>
                    <th>Sáb</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="week in weeks">
                    <td v-for="day in week" :class="dateClass(day)" v-on:click="handleDateSelection(day)">
                        <div class="date">{{ formatMonthDay(day) }}</div>
                        <div class="date-content">
                            <CalendarViewDate :date="day" :callback="renderDate"></CalendarViewDate>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { initialMonth, changeMonthByOne, mountInterval, checkDate, zeroPadd, formattedMonthName } from '../../common/calendar';

const CalendarViewDate = {
    props: {
        date: Object,
        callback: Function
    },
    render(createElement, ...rest){
        return createElement('div', [
            this.callback(this.date, createElement, ...rest)
        ]);
    }
};

export default {
    props: {
        initialMonth: Array,
        referenceDate: Date,
        onMonthChange: Function,
        onDateSelection: Function,
        renderDate: Function
    },
    data(){
        return {
            currentMonth: this.initialMonth || initialMonth()
        };
    },
    computed: {
        title(){
            return this.currentMonth !== null ? formattedMonthName(this.currentMonth) : '';
        },
        currentInterval(){
            if(this.currentMonth == null)
                return [];

            return mountInterval(this.currentMonth);
        },
        weeks(){
            let current = [];
            const weeks = [current];

            for(let day of this.currentInterval){
                current.push(day);

                if(current.length >= 7){
                    current = [];
                    weeks.push(current);
                }
            }

            return weeks;
        },
    },
    methods: {
        handlePreviousMonth(){
            this.changeMonth(-1);
        },
        handleNextMonth(){
            this.changeMonth(1);
        },
        changeMonth(num){
            this.currentMonth = changeMonthByOne(this.currentMonth, num);

            this.notifyMonthChange();
        },

        notifyMonthChange(){
            if(this.onMonthChange == null || this.currentInterval == null)
                return;

            const { currentInterval: itv } = this;
            const begin = itv[0];
            const end = itv[itv.length - 1];

            this.onMonthChange(this.currentMonth, begin, end);
        },

        dateClass(date){
            const classes = ['date-anchor'];

            if(this.onDateSelection != null)
                classes.push('selectable');

            if(checkDate(date, this.referenceDate))
                classes.push('today');
            else if(date.highlight)
                classes.push('highlight');

            return classes.join(' ');
        },
        handleDateSelection(day){
            if(this.onDateSelection != null)
                this.onDateSelection(day);
        },
        formatMonthDay(dt){
            return [
                zeroPadd(dt.date),
                zeroPadd(dt.month)
            ].join('/');
        }
    },
    mounted(){
        this.notifyMonthChange();
    },
    components: {
        CalendarViewDate
    }
}
</script>

<style scoped>
h4 {
    margin: 0;
}

.btn-toolbar {
    align-items: center;
}
.btn-toolbar .material-icons {
    line-height: inherit;
    font-size: 18px;
}

.calendar-grid {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 5px;;
}
.calendar-grid th, .calendar-grid td {
    box-sizing: border-box;
    width: 14.28%;
    padding: 0;
}
.calendar-grid th {
    height: 40px;
    text-align: center;
}
.calendar-grid td {
    height: 40px;
    text-align: center;
    border-radius: 5px;
    background: #eaeaea;
    color: #333;
}
.calendar-grid td.highlight {
    background: #ece4fd;
}
.calendar-grid td.highlight.selectable:hover {
    background: #C6B1F9;
}
.calendar-grid td.highlight.selectable:active {
    background: #AA8AF6;
}
.calendar-grid td.today {
    background: #56e5a6;
}
.calendar-grid td.today.selectable:hover {
    background: #4dc993;
}
.calendar-grid td.today.selectable:active {
    background: #44b181;
}

.calendar-grid td.date-anchor {
    cursor: default;
    font-weight: bold;
    vertical-align: top;
}
.calendar-grid td.date-anchor.selectable {
    cursor: pointer;
}

.calendar-grid .date-anchor {
    padding: 10px;
    text-decoration: none;
    color: #303036;
}
.calendar-grid .date-anchor .date {
    text-align: right;
    color: #333;
}
.calendar-grid .date-anchor .date-content {
    min-height: 60px;
}
</style>
